import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EyeTwoToneSvg from "@ant-design/icons-svg/es/asn/EyeTwoTone";
import AntdIcon from "../components/AntdIcon";
var EyeTwoTone = function EyeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EyeTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EyeTwoTone.displayName = 'EyeTwoTone';
}
export default /*#__PURE__*/React.forwardRef(EyeTwoTone);